import listItem from './list-item.vue';
import listingForm from '../form/form-vm.vue';
import draggable from 'vuedraggable';

export default {
  data() {
    return {
      courseId: null,
      modules: [],
      modulables: [],
      moving: null,
    };
  },
  components: {
    listItem,
    draggable,
    listingForm
  },
  mounted() {
    console.log('mounting module listing vm');
    this.$nextTick(() => {
      Kadenze.UIUtil.hideLoadingIndicator(); 
    });
  },
  methods: {
    bindData(courseId, modules, modulables) {
      this.courseId = courseId;
      this.modules = modules || [];
      this.modulables = modulables || [];
    },
    onUpdate(data, index) {
      this.$set(this.modules, index, JSON.parse(data));
      this.modules[index].prerequisite_ids.forEach((pid) => {
        _.find(this.modules, (m) => m.id == pid).is_prerequisite = true;
      });
    },
    onAdd() {
      this.modules.push({
        courseId: this.courseId,
        open: true,
        order: this.modules.length
      });
    },
    onDelete(index) {
      if ( this.modules[index].id ) {
        new Kadenze.AjaxRequest({
          url: Kadenze.Routes.course_learning_module_path(this.courseId, this.modules[index].id),
          method: 'DELETE',
        }).success(() => {
          this.modules.splice(index, 1);
          this.sort();
        });
      } else {
        this.modules.splice(index, 1);
      }
    },
    sort() {
      this.modules.forEach((module, i) => {
        this.$set(module, 'order', i + 1);
      });
      new Kadenze.AjaxRequest({
        url: Kadenze.Routes.sort_course_learning_modules_path(this.courseId),
        loadingIndicator: true,
        data: {
          modules: this.modules.map((i) => i.id)
        }
      });
    }
  }
};
